import { render, staticRenderFns } from "./popupReview.vue?vue&type=template&id=789c6e69&scoped=true&"
import script from "./popupReview.vue?vue&type=script&lang=js&"
export * from "./popupReview.vue?vue&type=script&lang=js&"
import style0 from "./popupReview.vue?vue&type=style&index=0&id=789c6e69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789c6e69",
  null
  
)

export default component.exports